/* PER-77 — per-item Subscribe & Save 15% toggle on the /cart page.
   Toggling ON swaps the line to the product's subscription selling plan (15%
   off); the frequency buttons (15/30/60 days) switch the plan. Toggling OFF
   reverts to a one-time purchase. Re-renders the items + footer sections in
   place (same mechanism as cart.js) so totals/savings stay in sync.

   The change listener is CAPTURE-phase + stopPropagation so it never reaches
   <cart-items>'s own quantity 'change' handler. */
(function () {
  if (window.__pcpCartSubInit) return;
  window.__pcpCartSubInit = true;

  // Mirror theme cart.js: re-render by the section INSTANCE id (data-id), not the
  // section file name — otherwise the footer renders standalone with no blocks
  // and the Order Summary comes back empty.
  function sectionsToRender() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var list = [];
    if (items) list.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    if (footer) list.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return list;
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function setBusy(box, busy) {
    box.style.opacity = busy ? '0.55' : '';
    box.style.pointerEvents = busy ? 'none' : '';
  }

  function changePlan(line, planId, box) {
    setBusy(box, true);
    var toRender = sectionsToRender();
    var body = {
      line: parseInt(line, 10),
      sections: toRender.map(function (s) { return s.section; }),
      sections_url: window.location.pathname,
    };
    body.selling_plan = planId ? parseInt(planId, 10) : null;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (!state || !state.sections) { window.location.reload(); return; }
        toRender.forEach(function (s) {
          var target = document.getElementById(s.id);
          if (!target) return;
          var dest = target.querySelector(s.selector) || target;
          var inner = getSectionInnerHTML(state.sections[s.section], s.selector);
          if (inner != null) dest.innerHTML = inner;
        });
        var bubble = document.querySelector('[data-header-cart-count], #count_counting');
        if (bubble && typeof state.item_count !== 'undefined') bubble.textContent = state.item_count;
      })
      .catch(function () { window.location.reload(); });
  }

  // Toggle on/off (capture phase so <cart-items> never sees this 'change').
  document.addEventListener(
    'change',
    function (e) {
      var check = e.target.closest && e.target.closest('.cart-amp__sub-check');
      if (!check) return;
      e.stopPropagation();
      var box = check.closest('.cart-amp__sub');
      if (!box) return;
      var line = box.getAttribute('data-sub-line');
      var planId = check.checked ? box.getAttribute('data-default-plan') : '';
      changePlan(line, planId, box);
    },
    true
  );

  // Frequency selection (15 / 30 / 60 days).
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.cart-amp__sub-opt');
    if (!opt) return;
    e.preventDefault();
    var box = opt.closest('.cart-amp__sub');
    if (!box || opt.classList.contains('is-active')) return;
    var line = box.getAttribute('data-sub-line');
    changePlan(line, opt.getAttribute('data-plan-id'), box);
  });
})();
